import React, { useState } from 'react';
import {
  Box,
  Tab,
  Tabs,
} from '@mui/material';
import BackfillPanel from './BackfillPanel.jsx';
import HistoryDashboardPanel from './HistoryDashboardPanel.jsx';
import { capabilitiesForProgram } from './programCapabilities.js';

const TabPanel = ({ active, children }) => (
  <Box role="tabpanel" hidden={!active} sx={{ pt: 2 }}>
    {active ? children : null}
  </Box>
);

const HistoryPanel = ({ program = 'website', serviceMonth, onBackfillImported = null }) => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const capabilities = capabilitiesForProgram(program);
  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={(_event, next) => setActiveTab(next)}
        sx={{ borderBottom: '1px solid', borderColor: 'divider', minHeight: 42 }}
      >
        <Tab value="dashboard" label="Dashboard" sx={{ textTransform: 'none', fontWeight: 800 }} />
        <Tab value="backfill" label="Backfill" sx={{ textTransform: 'none', fontWeight: 800 }} />
      </Tabs>
      <TabPanel active={activeTab === 'dashboard'}>
        <HistoryDashboardPanel program={program} supported={capabilities.historyDashboard} />
      </TabPanel>
      <TabPanel active={activeTab === 'backfill'}>
        <BackfillPanel program={program} serviceMonth={serviceMonth} onImported={onBackfillImported} />
      </TabPanel>
    </Box>
  );
};

export default HistoryPanel;
